interface ICountriesCardTitleParams {
  dimension?: string;
  metric?: string;
  chartType?: string;
}

const DEFAULT_DIMENSION = 'country';
const DEFAULT_METRIC = 'active_users';
const DEFAULT_CHART_TYPE = 'line';

const DIMENSION_KEY_MAP: IRecord<string> = {
  market: 'country',
  country: 'country',
  region: 'region',
};

const METRIC_KEY_MAP: IRecord<string> = {
  activeusers: 'active_users',
  active_users: 'active_users',
  avg_dau: 'active_users',
  revenue: 'revenue',
  sum_revenue: 'revenue',
  downloads: 'downloads',
  download: 'downloads',
  sum_download: 'downloads',
  D2: 'monthly_retention_d2',
  D3: 'monthly_retention_d3',
  D7: 'monthly_retention_d7',
  D15: 'monthly_retention_d15',
  D31: 'monthly_retention_d31',
  lifetime_retention: 'lifetime_retention',
  rpd: 'rpd',
  cumulative_revenue: 'cumulative_revenue',
  cumulative_download: 'cumulative_downloads',
  cumulative_downloads: 'cumulative_downloads',
};

const CHART_TYPE_KEY_MAP: IRecord<string> = {
  stackedLine: 'stacked_line',
  stacked_line: 'stacked_line',
  bar: 'bar',
  line: 'line',
  pie: 'pie',
};

const getMappedKey = (map: IRecord<string>, value?: string, fallback?: string): string => {
  if (value && map[value]) {
    return map[value];
  }

  return fallback || '';
};

export const getCountriesCardTitleI18nKey = (params?: ICountriesCardTitleParams | null): string => {
  const { dimension, metric, chartType } = params || {};
  const dimensionKey = getMappedKey(DIMENSION_KEY_MAP, dimension, DEFAULT_DIMENSION);
  const metricKey = getMappedKey(METRIC_KEY_MAP, metric, DEFAULT_METRIC);
  const chartTypeKey = getMappedKey(CHART_TYPE_KEY_MAP, chartType, DEFAULT_CHART_TYPE);

  return `dbi_mobile_detail_countries_card_title_${dimensionKey}_${metricKey}_${chartTypeKey}`;
};
